import { createMiddleware } from "@tanstack/react-start"

import { requireUser } from "@repo/supabase/require-user"
import { logger } from "@repo/utils/logger"
import { badRequestResponse, serverErrorResponse } from "~/lib/utils/http"
import { supabaseServerClientMiddleware } from "./supabase-server-client.middleware"

const log = logger.child({ module: "middleware/authenticated-session" })

export const authSessionMiddleware = createMiddleware({ type: "function" })
  .middleware([supabaseServerClientMiddleware])
  .server(async ({ next, context }) => {
    const supabase = context?.supabase

    if (!supabase) {
      log.error("No supabase client found")
      serverErrorResponse("No supabase client found", 500)
    }

    const { user, error } = await requireUser(supabase)

    if (error) {
      log.error("Error fetching user", { error })
      serverErrorResponse("Error fetching user", 500)
    }

    if (!user) {
      log.warn("No authenticated user found")
      badRequestResponse("No authenticated user found", 401)
    }

    if (context.posthog) {
      context.posthog.identify({
        distinctId: user.id,
        properties: {
          email: user.email,
          name: user.user_metadata.name,
        },
      })
    }

    return next({
      context: {
        user,
      },
    })
  })
